import { ModalDialogProps } from "react-bootstrap";
import { ClickEvent } from "../../shared/types/event.types";

export interface IModalProps extends ModalDialogProps {
  show: boolean;
  handleClose: () => void;
}

export const DefaultModalProps = {
  show: false,
  centered: true,
};
